import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface StepperConfig {
  labels: string[];
  totalSteps: number;
}

export const STEPPER_CONFIGS = {
  TRADING: {
    labels: ['Cotización', 'Resumen', 'Transferencia'],
    totalSteps: 3
  },
  INTERCHANGE: {
    labels: ['Cotización', 'Resumen'],
    totalSteps: 2
  },
  ONBOARDING: {
    labels: ['Inscripción', 'Conocimientos', 'Declaración jurada'],
    totalSteps: 3
  }
};

@Injectable({
  providedIn: 'root'
})
export class StepsService {
  private currentStepSubject = new BehaviorSubject<number>(0);
  currentStep$ = this.currentStepSubject.asObservable();
  private showStepSubject = new BehaviorSubject<boolean>(false);
  showStep$ = this.showStepSubject.asObservable();
  private readonly stepperConfigSubject = new BehaviorSubject<StepperConfig>(STEPPER_CONFIGS.TRADING);
  stepperConfig$ = this.stepperConfigSubject.asObservable();

  constructor() { }

  setStep(step: number) {
    this.currentStepSubject.next(step);
  }

  showStep(show: boolean) {
    this.showStepSubject.next(show);
  }

  hideStep() {
    this.showStepSubject.next(false);
  }

  setStepperConfig(configKey: keyof typeof STEPPER_CONFIGS) {
    this.stepperConfigSubject.next(STEPPER_CONFIGS[configKey]);
    this.currentStepSubject.next(0);
  }

  setCustomStepperConfig(config: StepperConfig) {
    this.stepperConfigSubject.next(config);
    this.currentStepSubject.next(0);
  }

  resetStepper() {
    this.currentStepSubject.next(0);
    this.showStepSubject.next(false);
  }
}
